<template>
  <div class="register">
    <div
      class="d-flex flex-column justify-content-center align-items-center register-header"
    >
      <h1 class="font-weight-bold fc-dark-blue">ลงทะเบียนสมัครใช้งาน Data Tagging Tool</h1>
      <div class="d-flex justify-content-center pt-3">
        <ul class="register-wizard">
          <li class="first" :class="{'done':user}">
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <p class="circle-step">
                <i class="fas fa-user-edit" :class="{'done':user}"></i>
              </p>
              <p class="font-weight-bold">กรอกข้อมูล</p>
            </div>
          </li>
          <li class="last" :class="{'done':user}">
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <p class="circle-step" :class="{'step-muted':!user}">
                <i class="fas fa-check"></i>
              </p>
              <p class="font-weight-bold">สำเร็จ</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <register-form @success="success" v-if="!user"></register-form>
    <register-success :user="user" v-if="user"></register-success>
  </div>
</template>

<script>
import RegisterForm from './registerForm.vue'
import RegisterSuccess from './registerSuccess.vue'
export default {
  components: { RegisterForm, RegisterSuccess },
  data () {
    return {
      user: null
    }
  },
  methods: {
    success (registerUserInfo) {
      this.user = registerUserInfo
    }
  }
}
</script>

<style scoped>
.register {
  font-family: 'Prompt', sans-serif !important;
}
.register-header {
  padding: 3rem 0;
  background-color: white;
}
.register-wizard {
  display: table;
  width: 50%;
  table-layout: fixed;
  margin: 0;
  padding: 0;
  list-style: none;
}

.register-wizard > li {
  display: table-cell;
  width: auto;
  vertical-align: top;
  text-align: center;
  position: relative;
}

.register-wizard > li:after {
  right: 0;
}
.register-wizard > li:before {
  left: 0;
}
.register-wizard > li:not(.last):after,
.register-wizard > li:not(.first):before {
  content: '';
  display: block;
  position: absolute;
  top: 1.5rem;
  width: 50%;
  height: 2px;
  background-color: #999999;
  z-index: 9;
}
.register-wizard > li.done:not(.last):after,
.register-wizard > li.done:not(.first):before {
  background-color: #25b372;
}
.circle-step {
  z-index: 10;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  border: 2px solid #25b372;
  background-color: #25b372;
}

.circle-step .done:before {
  content:'\f00c'
}

.step-muted {
  color: #999999;
  border-color: #999999;
  background-color: white;
}

</style>

<style>
.fc-dark-blue {
  color:#141B4D;
}
</style>
